<script setup >
const tableData = ref([
  { name: "减免事项附表", person: 0, total: "0.00", status: "无需填写" },
  { name: "商业健康保险附表", person: 0, total: "0.00", status: "无需填写" },
  { name: "税延养老保险附表", person: 0, total: "0.00", status: "无需填写" },
])
</script>

<template>
    <div class="def_wrap">
        <p class="type">
            <span class="title">2026年01月 其他附表</span>
        </p>
        <p class="info">1.综合所得申报表中填写“减免税额" 的需填写减免事项附表</p>
        <p class="info">2.在本期其他扣除中填写了"商业健康保险"的需填写商业健康保险附表</p>
        <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="name" label="所得项目名称" />
            <el-table-column prop="person" label="填写人数" />
            <el-table-column prop="total" label="金额合计" />
            <el-table-column prop="status" label="填写状态" />
            <el-table-column  label="操作" />
        </el-table>
    </div>
</template>

<style lang="scss" scoped>
.def_wrap {
  width: 100%;
  width: 100%;
  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
    }
  }
  .info{
    padding: 10px 0;
  }
  :deep(.el-table) {
    --el-table-header-bg-color: #f8f9fa;
  }
}
</style>
